import React from 'react';
import Text from './Text';
import theme from '../theme';
import fn from '../../helpers/fn';

const Label = Text.withComponent(({ children, small, ...props }) => (
  <label htmlFor="x" {...props}>{children}</label>
));

export default fn(__filename, Label.extend`
  margin-bottom: ${theme.unit}px;
  font-weight: 600;
  color: ${theme.colors.gray3};

  ${({ large }) => large && `
    display: block;
    font-size: 26px;
    font-weight: 400;
    margin-bottom: ${theme.unit * 2}px;
  `}

  ${({ medium }) => medium && `
    display: block;
    font-size: 21px;
    font-weight: 400;
    margin-bottom: ${theme.unit * 2}px;
  `}

  ${({ small }) => small && `
    color: ${theme.colors.gray3};
    font-size: 13px;
    position: absolute;
    top: 4px;
    left: 13px;
  `}
`.withComponent(({
  large, medium, small, // strip
  children,
  ...props
}) =>
  <Label {...props}>{children}</Label>,
));



// WEBPACK FOOTER //
// ./src/components/text/Label.js